import { useCallback } from 'react'
import { useReserveNavigate } from '~/navigation'
import { useDisabledOnsite } from '../../store/paymentMethod'
import { usePaymentMethod } from '../../store/stateMachine/context'
import { useReserveInfo, useTransition } from '../../store/stateMachine/state'

type OnlinePayment = {
  selectedPaymentMethod: string
  /** ラジオボタンを表示するかどうか制御する */
  disabled: boolean
  /** ラジオボタン自体の disabled 属性を制御する */
  radioDisabled: boolean
  checkedOnline: () => void
  open: () => void
}

export function useOnlinePayment(): OnlinePayment {
  const selectedPaymentMethod = usePaymentMethod()
  const send = useTransition()
  const disabled = useDisabledOnsite()
  const radioDisabled = useReserveInfo()?.gmoMaintenance ?? false
  const checkedOnline = useCallback(() => {
    send({ type: 'updated', paymentMethod: 'ONLINE' })
  }, [send])
  const navigate = useReserveNavigate()
  const open = useCallback(() => {
    navigate({ type: 'showCreditCard' })
  }, [navigate])
  return {
    selectedPaymentMethod,
    disabled,
    radioDisabled,
    checkedOnline,
    open,
  }
}
